// This icon file is generated automatically.
var PFileExclamationOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.35 3.5L9 .16A.5.5 0 008.64 0H2a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h10a.5.5 0 00.5-.5V3.86a.5.5 0 00-.15-.35zm-1 .6H8.4V1.14l2.94 2.94zm.03 8.78H2.62V1.12h4.72V4.5c0 .36.3.66.66.66h3.38v7.71zm-5-2.26a.62.62 0 101.24 0 .62.62 0 00-1.25 0zM6.63 9h.75c.06 0 .12-.06.12-.13V6a.13.13 0 00-.13-.13h-.75A.13.13 0 006.5 6v2.88c0 .06.06.12.13.12z", "fill-rule": "nonzero" } }] }, "name": "p-file-exclamation", "theme": "outlined" };
export default PFileExclamationOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFileExclamationOutlined.js
// module id = 3391
// module chunks = 0